module.exports = __webpack_public_path__ + "static/media/logo-white.3707571a.svg";